/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Toolbar_Secondary_Import_Media_TitleInputs */



/**
* | output |
* | --- |
* | "Import Media File" |
*
* @param {Toolbar_Secondary_Import_Media_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const toolbar_secondary_import_media_title = /** @type {((inputs?: Toolbar_Secondary_Import_Media_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Toolbar_Secondary_Import_Media_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Importer un Fichier Média")
	if (locale === "de") return /** @type {LocalizedString} */ ("Mediendatei importieren")
	if (locale === "it") return /** @type {LocalizedString} */ ("Importa file multimediale")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Импорт медиафайла")
	if (locale === "es") return /** @type {LocalizedString} */ ("Importar archivo multimedia")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("导入媒体文件")
	if (locale === "ja") return /** @type {LocalizedString} */ ("メディアファイルのインポート")
	if (locale === "hi") return /** @type {LocalizedString} */ ("मीडिया फ़ाइल आयात करें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Importar arquivo de mídia")
	return /** @type {LocalizedString} */ ("Import Media File")
});